<template>
  <div :class="['con-scroll', className]">
    <div class="con-item con-item-active">
      <img :src="getMember(captain.nick_img).avatar" alt="" />
      <i>队长</i>
    </div>
    <div class="con-item con-item-active" v-for="m in teamMembers" :key="m.uin">
      <img :src="getMember(m.nick_img).avatar" alt="" />
      <span v-show="now-new Date(m.join_time*1000)<=24*60*60*1000">new</span>
    </div>
  </div>
</template>

<script>
import { getStrParams } from "../../bargain/utils/url"

export default {
  name: "TeamMembers",
  props: ["teamMembers", "defaultAvatar", "defaultNickname", "now", "captain", "className"],
  methods: {
    /**
     * 获取团员的头像昵称
     */
    getMember(str) {
      let obj = getStrParams(decodeURIComponent(str), true)
      let nickName = this.defaultNickname
      if (obj?.nick_name) {
        try {
          nickName = decodeURIComponent(obj.nick_name)
        } catch (error) {
          nickName = obj.nick_name
        }
      }
      let avatar = obj.img_url || this.defaultAvatar
      return {
        avatar,
        nickName
      }
    }
  }
}
</script>

<style scoped>
</style>
